<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="../assets/favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="login">
      <div class="d-flex align-items-center min-vh-100 bg-auth">
        <div class="container">
          <div class="justify-content-center row">
            <div class="my-5 col-xl-4 col-md-5 col-12">
              <h1 class="display-4 text-center mb-3">Ingresar</h1>
              <p class="text-muted text-center mb-5">Ingresar a tu cuenta</p>
              <form v-on:submit.prevent="login">
                <div class="form-group mb-3">
                  <label class="form-label">Email</label
                  ><input
                    name="login"
                    v-model="email"
                    type="email"
                    placeholder="name@address.com"
                    class="form-control"
                  />
                </div>
                <div class="form-group mb-3">
                      <label class="form-label">Password</label>
                    <input
                      type="password"
                      placeholder="Password"
                      class="form-control"
                      v-model="password"
                      name="login"
                    />
                  <div class="input-group-merge input-group">
                    <div class="col-auto">
                      <a
                        v-on:click="goToPage('Recovery')"
                        class="small text-muted form-text"
                        style="cursor: pointer"
                        >No recuerdo mi contraseña</a
                      >
                    </div>
                  </div>
                  <br />
                  <br />
                </div>

                <div class="row">
                    <div class="col">
                      <button type="submit" class="w-100 mb-3 btn btn-primary btn-lg">
                  Ingresar
                </button>
              </div>   
                <div class="col">
                <button v-on:click="goToPage('Register')" type="button" class="w-100 mb-3 btn btn-primary btn-lg">
                  Crear cuenta
                </button>
                    </div>   </div>   
              
               
              </form>
            </div>
          </div>
        </div>
      </div>
      <PopUp :show="error" @close="error = false">
        <template #body>
          <p>{{ error_msg }}</p>
        </template>
      </PopUp>
    </body>
  </html>
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import PopUp from "../components/PopUp.vue";

export default {
  name: "Login",
  components: { PopUp },
  data: function () {
    return {
      email: "",
      password: "",
      error: false,
      error_msg: "",
    };
  },
  methods: {
    login() {
      let json = {
        email: this.email,
        password: this.password,
      };
      axios
        .post("/login-resto", json)
        .then((data) => {
          axios
            .get("/usuarios/" + data.data.usuario_id)
            .then((user) => {
              if (user.status == 200) {
                localStorage.token = data.data.rol_token;

                localStorage.setItem("email", this.email);
                //this.$router.push("perfil");
                axios
                  .get(
                    "/getPasosCompletosRegistro?mail=" +
                      encodeURIComponent(this.email)
                  )
                  .then((data) => {
                    // Si no se completaron todos los pasos del registro
                    if (data.data != 8) {
                      this.$router.push({
                        name: this.$parent.pasos[data.data],
                      });
                    } else {  
                      if(this.$route.query.redirect) {
                        this.$router.push({ name: this.$route.query.redirect });
                      } else {
                        this.$router.push({ name: "inicio" });
                      }
                    }
                  });

              }
              else {
                  console.log(data);
                  this.error = true;
                  this.error_msg =
                    "Este usuario no tiene permisos para acceder a esta pagina, por favor cree una cuenta nueva";
                }
            });
        })
        .catch((e) => {

          if (typeof e === 'string' || e instanceof String){
            this.error_msg =e
            this.error = true;
          }else{
            if (!e.response) {
            this.error_msg =
              "No hay conexion con el servidor, intente nuevamente mas tarde";
          } else {
            this.error_msg = e.response.data.message;
          }
          this.error = true;

          }
         
          
        });
    },
    goToPage(page) {
      this.$router.push({ name: page });
    },
  },
  mounted() {
    if(this.$route.query.redirect && !this.$route.query.logout && localStorage.token) {
      this.$router.push({ 
        name: this.$route.query.redirect,
        query: { redirect: this.$route.query.redirect } 
       });
    }
  }
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}


</style>
